module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("CHAPTER 2")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("T")])])])]), _vm._v("hinking of the evening ahead, Claire turned onto a tree-shaded street in Old Town, Alexandria. After her husband’s death, she’d sold their colonial-style home in the suburbs and purchased a three-story townhome. Not only was it closer to her downtown D.C. office, but renovating the town house helped blunt some of her soul-searing grief.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her home was one of four carved out of an eighteenth-century brick warehouse that had once stored huge barrels of tobacco awaiting shipment from the New World to the Old. Claire had sanded the oak plank floors herself and roamed antique stores on weekends for just the right doorknob and "), _c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("lamp. She’d chosen light, neutral fabrics for the furniture, with jewel-toned throw pillows for the occasional splash of color. Plantation shutters graced the windows throughout the house instead of drapes. In her considered opinion, the result was a perfect blend of new and old, of sunlight and space.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The tranquility of her home welcomed her as she took the stairs from the ground-floor garage to an entry hall lined with oak plank flooring. Once inside, she decided to change before dictating her notes. When working with clients, she wore suits or pantsuits in cool, soothing colors that, theoretically at least, put them at ease. At home she preferred hip-hugging sweats and comfortable T-shirts.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Unless Luis was coming for dinner. Or sex. Or both.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With those tantalizing possibilities ahead, she deposited her briefcase on the foyer table and detoured to the den to click on the built-in stereo system. Humming along with Etta James’s smoky rendition of “At Last,” she went upstairs.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As always, when she entered her bedroom her glance went first to the crystal-framed photo on the bedside table. It was one of her favorites, snapped during her honeymoon in Hawaii. She and Dave were laughing and splashing through the surf. He looked like he was about to lose his "), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("baggy bathing trunks to the undertow. Claire waved to the camera, hoping her new husband didn’t moon the woman who’d obligingly offered to take the picture.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hard to believe we were ever that young,” she murmured with a smile.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stifling a familiar pang of regret for the years she and Dave had lost, she exchanged her suit for loose-fitting linen slacks with a drawstring waist. She topped those with a colorfully embroidered, off-the-shoulder top she’d picked up during a visit to Cartoza with Luis. He’d taken such delight in showing her his country, she in meeting his friends and family. His parents were dead, but he remained close to his brother, a clutch of sisters, a lively brood of nieces and nephews, and the rather intimidating matriarch of the Esteban clan—a blunt-spoken nonagenarian they all called Tia Maria.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Smiling at the memory of Tia Maria’s observation that it was about time Luis chose a woman for her sense instead of her chest size, Claire slid her feet into thong sandals and descended to the kitchen on the main floor of the town house. Cooking for Luis always challenged her admittedly limited culinary skills. Dave had been pretty much a meat-and-potatoes man. Claire’s tastes were somewhat more eclectic, but nowhere near Luis’s sophisticated palate. Since he’d burst into her life, "), _c('a', {
    attrs: {
      "id": "page22"
    }
  }), _vm._v("he’d introduced her to exotic delicacies she would never have tried on her own.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Thank goodness she had two swordfish steaks in the freezer. While they defrosted in the microwave, she prepared a marinade of lemon juice and white wine. After dousing the steaks, she stuck them back in the fridge. Sprinkled with slivered almonds and arranged on a bed of crushed tomatoes, they would broil in minutes. She assembled a fresh spinach salad and put that into the fridge, too. With crusty French bread and a side of wild rice, the meal should satisfy even Luis’s discerning tastes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dinner taken care of, Claire went down the hall to the room she’d had custom-fitted as a combination library, office and retreat. Bookshelves lined three walls, high-tech electronic gear the fourth. Her favorite novels and biographies vied for space in one section of shelves. Psychology journals and reference books filled the rest.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She went first to check her faxes. She found one from the White House—a confidentiality agreement she needed to sign and return before they would release Stacy Andrews’s medical information, including the results of her most recent blood test. Claire read the agreement carefully. Satisfied it conformed to her own professional standards concerning client privacy, she signed "), _c('a', {
    attrs: {
      "id": "page23"
    }
  }), _vm._v("and dated it. Once she’d faxed it back, she powered up her computer and switched on voice recognition mode.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Notes from session with Stacy Andrews, fourteen-year-old female, who’s experienced two vivid nightmares with debilitating sleep interruption.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She noted the date, time and place of the consultation and described in detail her observations and discussion with the president’s daughter. When she finished the dictation, she switched to a powerful search engine that gave her access to a host of databases. Those included the Clinical Psychology Network, with its more than five thousand links, and the American Psychiatric Association’s "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Diagnostic and Statistical Manual of Mental Disorders")])]), _vm._v(". The link she was most interested in at the moment took her to the National Sleep Foundation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Claire knew Freud believed dreams expressed unconscious desires, but modern research had tied them to the REM cycle. REM sleep began with a signal from the pons at the base of the brain. The signal was relayed to the cortex, which controlled learning, thinking and organizing information. Although scientists had yet to definitively determine what actually caused dreams, one theory held that the cortex received fragmented signals from the pons and tried to sequence them into thoughts or scenes.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Everyone dreamed. Not everyone remembered their dreams when they woke up. But if the REM cycle was suddenly interrupted or the dreams were vivid or frightening, the sleeper might jerk wake. In that case, they could retain detailed images, as had happened with Stacy Andrews.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Chewing on her lower lip, Claire slid a pad toward her and began making copious notes on the symptoms and treatment for nightmares. That led her to the rare but very dangerous condition known as REM Sleep Behavior Disorder, when individuals got out of bed and began physically acting out their dreams while asleep.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was still hard at work when the door chimes rang. Startled, she glanced at her watch. Good thing she’d prepared the swordfish before getting lost in her research.")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("When she opened the door, Luis had to fight to keep his smile lazy. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Madre de Dios!")])]), _vm._v(" Did the woman have any idea how seductive she looked?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The last slanting rays of the sun deepened the gold in her pale blond hair and gave her skin a creamy tint. His pulse quickening, Luis followed the clean line of her throat to the slope of her shoulders so enticingly displayed by her blouse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She excited him in her usual attire of severely "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }), _vm._v("tailored suits and pumps. Cool and serene, she stirred fantasies of slowly stripping away her outer clothing piece by piece until he roused the passion he knew lay underneath.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Like this, though, with her hair falling in a soft cloud to her shoulders and those drawstring pants riding low on her hips, she shoved all thoughts of slow out of his head. His groin tightened, and his greeting took on a husky note.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Buenas tardes, mi corazón.”")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Buenas tardes")])]), _vm._v(", Luis.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her reluctance to use pet names or endearments amused him as much as it had begun to irritate him. He was no overeager young stud. He’d loved passionately once, long ago. Since then, he’d enjoyed mutually satisfying liaisons with a fair number of women. Sophisticated women for the most part, who knew how the game was played and enjoyed playing it. Luis had worked hard to give them as much pleasure as they’d given him. He’d also made sure he parted with each on amicable terms.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But this one, this reserved, self-contained beauty, challenged his masculinity in a way no other woman had. Even in their most intimate moments, she held back a part of herself. Luis hadn’t minded at first. He understood and respected her need for privacy "), _c('a', {
    attrs: {
      "id": "page26"
    }
  }), _vm._v("in some corners of her life. He was a man with many secrets himself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yet what had begun as a familiar, sexual dance had gradually become a test of his will. And hers. One day, he vowed, he’d break through the wall she’d built around her heart since her husband’s brutal murder.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Dinner will be ready shortly,” she said as the door closed behind him. “I just have to broil the…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He snagged her arm, tugged her around.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“First things first.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Depositing the wine he’d brought on the hall table, he thrust his free hand into her hair. The strands threaded between his fingers like air-spun silk.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I missed you while I was in Cartoza, preparing for President Andrews’s visit.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I missed you, too.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She came into his arms readily and her mouth opened under his. That should have been enough. That, and the way she hooked her arms around his neck and rose up on tiptoe to return the kiss.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Despite her ready kiss—or perhaps because of it—Luis wanted more. Perhaps it was his still-simmering frustration over the president’s canceled trip. Perhaps it was the insult from that ass, Fogarty. Whatever it was spurring him sharpened his desire for this woman to a deep, driving need.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He angled his head, found her tongue with his. His hands roamed her back, slid down to cup her bottom and press her against him. He was already hard and aching for her, which made her draw back a little.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Before dinner?” she asked, with a smile in her eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Before, during and after,” he growled, scooping her into his arms.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His heels rang on the hardwood stairs as he carried her up to the master bedroom. The decor was all Claire—oyster-colored walls, framed Impressionist prints, an inch-thick Turkish carpet in muted jewel tones. Nothing harsh, nothing jarring, everything perfect and in place.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Including the photo in a crystal frame on her bedside table.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luis wasn’t jealous of the husband Claire had loved and lost. On the contrary, that soul-shattering experience had moulded her into the woman she was today. Strong. Self-reliant. Incredibly skilled, both in her profession and the dangerous undercover ops she worked for OMEGA.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Too strong at times. Too self-contained. What ate at him was the knowledge she’d entered this relationship for the same reasons "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("he’d")])]), _vm._v(" entered it. For friendship and intellectual stimulation, as much as sexual satisfaction. The problem was, she seemed content with that.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The atavistic urge to disrupt the tranquil harmony of both the room and the woman in his arms gripped him. A little roughly, he deposited her on the bed and stood over her while he unbuckled his belt and shed his clothing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her gaze swept down his chest and flat belly to linger on the erection jutting from the nest of dark hair at his groin. “You "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("have")])]), _vm._v(" missed me,” she said with a teasing smile.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luis was in no mood for teasing. He wanted her wet and hot, as hungry for him as he was for her. At some deeper, primal level, he also wanted her to acknowledge him as a mate as worthy of her as the husband she’d lost.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He took time only to unstrap the ankle holster that was as much a part of him as his suspicious nature and various scars. Naked, he came down beside her. Stretching her arms above her head, he captured her wrists with one hand and yanked at the ties of her slacks with the other.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her eyes widened, but she obligingly kicked off her sandals and raised her hips. In one swift move, Luis rid her of both slacks and lacy briefs. He tugged up the hem of her blouse, well aware of the fact that she rarely wore a bra at home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She didn’t need one. Her breasts were small and firm and tipped with pink nipples that rose to "), _c('a', {
    attrs: {
      "id": "page29"
    }
  }), _vm._v("stiff peaks when he suckled them. Mounding the creamy flesh with his free hand, he bent his head.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Claire dragged in a swift breath. She wasn’t sure what lay behind this sudden, Neanderthal approach to sex, but her body responded to it. Her back arched as Luis used his tongue and teeth on her. Pleasure streaked from her breasts to her belly, and her womb clenched in a tight spasm. She could feel the tension building, feel her nerves ignite every place his silky mustache prickled her skin.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His mouth was hot and demanding, his knee insistent, as he wedged it between hers and pried them apart. The psychologist in Claire analyzed the negative cognitions of sexual dominance even as the woman in her responded to his strength and unerring skill.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Luis,” she panted, tugging at her wrists. “Let me touch you. Let me pleasure you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Next time, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("querida")])]), _vm._v(". This time, I want to pleasure you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was good at it. So damned good. His muscled thigh pressed against her sensitive flesh. His mouth claimed hers. When he finally released her wrists and hooked an arm around her waist to position her under him, Claire was wet and ready. And very grateful for the fact they didn’t have to resort to condoms.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d started birth control again before deciding to yield to Luis’s blatant attempts at seduction, but was well aware of his numerous past conquests. They’d been cautious at first, always using the extra protection of a condom. She trusted him enough now, though, to believe him when he swore she was the only woman in his life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For the moment, anyway. She had no idea how long that would last, but until circumstances changed, she had not the slightest hesitation about welcoming him eagerly into her body.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When he entered her, she could feel each hot, ridged inch. His first thrusts were swift, hard, possessive. She lifted her hips to meet them, and they soon moved together in a rhythm that grew more urgent, more intense, with each grind of their hips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her climax began as a swirl of tight, dark sensation. She felt it spiraling up from her belly, tried to contain it. When the sensations exploded in a starburst of exquisite pleasure, she threw her head back, arched her spine and rode the crest.")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("“Well, we certainly worked up an appetite.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Smiling, Claire sipped her frothy cappuccino and surveyed the remnants of the dinner they’d eaten on the deck. A fat candle flickered inside a glass hurricane lamp. Tiny white lights strung through the "), _c('a', {
    attrs: {
      "id": "page31"
    }
  }), _vm._v("vines twisting around the trellised roof added to the glow of a full moon.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d pulled on lacy briefs and a celery-colored silk caftan. Luis’s scent still clung to her skin, mingling with the fragrant cherry-and-rum aroma of his thin cigarillo and the chocolaty steam rising from the cup she held cradled in both hands.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He sat across from her. He’d raked a hand through his dark hair and left his shirt hanging out, half-buttoned. She liked him this way, Claire mused, as her gaze drifted to the V of bronzed skin dusted with curling black chest air. Relaxed. Comfortable. He was usually so polished and urbane. So much in control. The colonel might have left the military years ago, but the military hadn’t left him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Tell me what happened in Cartoza,” she requested.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m damned if I know.” He leaned back in his chair and blew out a cloud of smoke. “I thought everything was going well. President and Señora Diaz welcomed the Andrews to Cartoza with a family luncheon. That afternoon, the two presidents attended the opening session of the Organization of American States. Andrews was welcomed warmly despite the United States’ difficulties with some Latin-American countries.”")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Like Venezuela,” Claire murmured, remembering a particularly nasty op another OMEGA agent had worked on that country’s border some months back.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Like Venezuela,” Luis echoed. “While the politicos attended to business, Señora Diaz gave Stacy a tour of the capital. They were accompanied by the fourteen-year-old girl who recently won our national spelling bee. And, of course, a full contingent of both U.S. and Cartozan security forces. I vetted every one of our people myself.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Claire didn’t doubt it. As former chief of Cartoza’s security forces, Luis would not take the challenges associated with a visiting head of state lightly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The first nightmare came well after midnight, close to four a.m. I didn’t learn of it until several hours later. I also learned the physician accompanying Andrews’s party had administered a sedative and Stacy had slept for the rest of the night.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Frowning, he rolled the thin cigar in his fingers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She appeared happy and quite normal the next morning, although you could see the fatigue in her eyes. We altered her schedule so it included only the events we thought she would most enjoy. Stacy and Rosa—the spelling bee champion—splashed in the Dolphin Cove with a group of other youngsters. That afternoon they attended a village fiesta. It was very "), _c('a', {
    attrs: {
      "id": "page33"
    }
  }), _vm._v("colorful, crowded and noisy, but I swear to you, Claire, my people tested everything before she ate or drank it. I’m ninety-nine-point-nine percent certain no one slipped her any kind of drug or hallucinogen.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It certainly seems unlikely, but you and I have been in this business long enough to know anything is possible. So the second nightmare occurred that night, after the fiesta?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It did.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His mouth grim, Luis stubbed out his cigarillo in the ashtray Claire kept out on the deck for his use. He never lit up inside and always took care to stand or sit downwind, so as not to expose her to secondhand smoke.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She would have liked him to give the habit up completely, but the casual nature of their relationship didn’t give her the right to request that kind of behavioral modification. Unless or until that relationship changed, she actually enjoyed an occasional whiff of the rum-and-cherry smoke.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Did the White House fax you the results of the blood test they administered after the second nightmare?” he wanted to know.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I had to sign and send back a confidentiality agreement first. The results may have come in in the past few hours…while I was otherwise engaged.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Will you inform me if the actual results are different from what I was told?”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her calm reply produced only a small shrug. Luis had learned enough about Claire’s profession—and about her—during their months together to have expected no other answer. He also knew she would do her best to keep him in the loop, however. Especially with his prickly macho pride and national honor at stake.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If they "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("are")])]), _vm._v(" different,” she assured him, “I’ll ask Stacy or her father if I can discuss them with you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She tapped a nail against her cappuccino cup. A item from the notes she’d dictated tugged at her thoughts.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Do you know what the women at the fiesta were wearing? The village women?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The question surprised him. “Their best garments, I would guess. As you know well, the women of my county love bright colors. They would have worn ruffled skirts in red and turquoise and green. Embroidered blouses trimmed with colorful ribbons. That sort of thing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What about on their heads?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The girls usually wear garlands of flowers, the older women lace mantillas.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Flowers and lace, not kerchiefs?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Some may have covered their hair with cloth mantles. Why do you ask this?”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It was just something Stacy said. A fragment of the dream she remembered.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luis’s gaze sharpened. “You think a woman wearing a head covering may have frightened her and caused her to have these nightmares?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I haven’t formulated any viable theories as to their root cause yet. I had just dictated my notes and begun my research when you arrived.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Nevertheless, I’ll query the captain who commanded her escort and have him review the footage from the festival. If Stacy spoke to or came in contact with a woman wearing a mantle, it should be on the surveillance videos.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Being able to take some action, any action, seemed to reenergize him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Are you done with your cappuccino, my heart? If so, I’ll carry the dishes into the kitchen.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m finished.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she rose to help gather the plates, he nudged her aside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You cooked, I’ll clean. Go, finish this research I interrupted. Then "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("we")])]), _vm._v(" will finish what we began earlier.”")])]), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Luis made sure their second session was as slow and sweet as the first was fierce. He would have made it last until dawn, if Claire hadn’t finally driven him over the edge.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His chest heaving, he sprawled bonelessly amid the tangled sheets until the world stopped spinning. She lay with her head nested on his shoulder, her hair spilling across his chest and the musky scent of their lovemaking teasing his nostrils. Idly, he played with strands of her hair as the thoughts that had tugged at him when she’d opened the door to him earlier once again played through his mind.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Why couldn’t he seem to get enough of this slender, maddeningly independent woman? How was it that she satisfied his every carnal desire, yet left him wanting more?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("God knows he was a self-professed connoisseur of women. Some he’d admired for their beauty, some for their intelligence or talent or sparkling personalities. But this one…This one stirred urges that edged dangerously close to that vague, ill-defined emotion the poets labeled love.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luis had teetered on the brink of that emotion only once before. The affair had flamed hot and ended in a murderous cross fire. Since then, he’d limited himself to mutually satisfying liaisons with no commitments on either side. Yet lying here, stroking Claire’s hair, breathing in her scent…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Shall I stay the night, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("querida")])]), _vm._v("?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What time is it?” she murmured sleepily.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He flicked a look at the bedside clock. His glance "), _c('a', {
    attrs: {
      "id": "page37"
    }
  }), _vm._v("lingered on the crystal frame for a second before he replied.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Almost two.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Mmm.” She buried her nose in the warm skin of his neck. “Too late for you to drive back into the city and rouse the embassy staff. Stay the night.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What if I stay longer?” He gave her hair another slow stroke. “Or don’t leave at all?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The question bought her blinking awake, as he’d known it would. Pushing upright, she propped herself on an elbow. Her hair fell across her forehead. When she hooked the loose strand behind her ear, he saw her face clearly in the moonlight streaming through the top half of the plantation shutters. Saw, too, the question in her eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We agreed up front that we both need our space, Luis. We discussed boundaries.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Perhaps it’s time to renegotiate those boundaries.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I want more of you, Claire.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You have all I’m prepared to give right now,” she said quietly. “All I "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("can")])]), _vm._v(" give.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was formulating his response to that when the phone beside the bed shrilled. Rolling over, she lifted the receiver.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Dr. Cantwell.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A few clicks sounded, then a disembodied voice "), _c('a', {
    attrs: {
      "id": "page38"
    }
  }), _vm._v("announced that the line was secure. That was followed by a terse request that came through clearly enough for Luis to overhear.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“This is Tom Fogerty, Dr. Cantwell. Can you come to the Executive Residence right away?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course. Is it Stacy?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes. She’s had another episode. She’s sobbing hysterically and asking for you.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b506226","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter02.vue
// module id = 69
// module chunks = 0